// Services
import axios from "axios";
import { getUrlService } from "services/beApi/utilityBeApi";

// Constants
import { BeApiServiceEnum } from "constants/searchPage/BeApiEnum";

// Types
import { ApiResponse } from "interfaces/shared/api";
import { UserInfo } from "interfaces/shared/userInfo";

export const APIGetUserInfo = (typeService: BeApiServiceEnum): Promise<ApiResponse<UserInfo>> => {
	return axios.get(getUrlService(typeService));
};

export const APIGetUserInfoNoCache = (typeService: BeApiServiceEnum): Promise<ApiResponse<UserInfo>> => {
	const config = {
		headers: {
			"Cache-Control": "no-cache",
		},
	};
	return axios.get(getUrlService(typeService), config);
};
